import React, { useEffect, useState } from "react"

import { Button, Flex, Input, useMantineTheme } from "@mantine/core"
import { Carousel } from "@mantine/carousel"
import { useDisclosure } from "@mantine/hooks"
import { Tile } from "@quorumus/plum"

import { Icon } from "@/components"
import { useStyles } from "@/pages/home/components/DesktopLandingPage.styles"
import { AdvancedSearchTipsModal } from "@/components/TopNavigation/components/AdvancedSearchTipsModal/AdvancedSearchTipsModal"

import FavoriteAndRecentUserActionsViewer from "app/static/frontend/favorites/containers/FavoriteAndRecentUserActionsViewer"

import * as Logos from "quorum/static/frontend/marketing-website/constants/logos"
import { getSearchPath, getCurrentWebSearchOptions } from "app/static/frontend/search-new/routes"

// -- migrated from app/static/frontend/containers/LandingPage.jsx -- //

export const DesktopLandingPage = (props) => {
    // styles
    const theme = useMantineTheme()
    const { classes } = useStyles()
    const [isSearchTipsOpen, searchTips] = useDisclosure(false)

    // state
    const [searchLandingTerm, setSearchLandingTerm] = useState("")
    const searchOptions = getCurrentWebSearchOptions()

    // componentDidMount
    useEffect(() => {
        // clear search term when mounting (on initial load and also after clicking Q)
        props.setSearchTerm(undefined)
    }, [])

    const search = (query) => {
        props.setSearchTerm(query)
        props.segueToSearch({ initialFilter: { advanced_search: query } })
    }

    const renderSearchBar = () => {
        return (
            <form
                onSubmit={(event) => {
                    event.preventDefault()
                    event.stopPropagation()

                    const query = (event.currentTarget.elements[0] as HTMLInputElement).value
                    search(query)
                }}
            >
                <Input
                    className={classes.searchbarWrapper}
                    icon={<Icon icon="search" color={theme.colors.violet[5]} />}
                    onChange={(event) => setSearchLandingTerm(event.currentTarget.value)}
                    placeholder="Search..."
                    rightSection={
                        <Button className={classes.searchbarInfo} onClick={searchTips.toggle} variant="subtle">
                            <Icon icon="info-circle" color={theme.colors.gray[7]} />
                        </Button>
                    }
                    size="lg"
                />
                <AdvancedSearchTipsModal isOpen={isSearchTipsOpen} searchTips={searchTips} />
            </form>
        )
    }

    const renderLinkItem = (item) => {
        const id = item.uniqueFlvId
        const pathname = getSearchPath(item)
        const icon = item.quorumDataType.fa5_icon
        const iconFamily = item.quorumDataType.fa5_icon_family
        const query = (searchLandingTerm && { advanced_search: searchLandingTerm }) || {}

        let label = item.label || item.quorumDataType.plural
        if (
            // Comms only user/org label change for Documents
            item.quorumDataType.value === DjangIO.app.models.QuorumDataType.document.value &&
            props.isCommsOnlyUser
        ) {
            label = "Social Media"
        }

        return (
            <Carousel.Slide key={id}>
                <Tile
                    icon={<Icon icon={icon} iconFamily={iconFamily} />}
                    orientation="vertical"
                    size="md"
                    variant="primary"
                    onClick={() => props.segue({ pathname, query })}
                >
                    {label}
                </Tile>
            </Carousel.Slide>
        )
    }

    return (
        <Flex align="center" justify="center" className={classes.landingPageWrapper}>
            <Flex direction="column" gap="1.5rem" className={classes.landingPage}>
                <div
                    className={classes.quorumBanner}
                    data-cy="quorum-homepage-logo"
                    dangerouslySetInnerHTML={{ __html: Logos.newWhiteLogoSvg }}
                />
                {renderSearchBar()}
                <Carousel
                    // loop
                    align="start"
                    containScroll="trimSnaps"
                    slideSize="10rem"
                    slideGap="1rem"
                    slidesToScroll="auto"
                    styles={{
                        container: {
                            padding: "0.125rem 0",
                        },
                        control: {
                            background: theme.fn.linearGradient(90, "rgba(255, 255, 255, 0)", "rgba(255, 255, 255, 1)"),
                            border: "none",
                            borderRadius: 0,
                            boxShadow: "none",
                            color: theme.colors.gray[7],
                            height: "100%",
                            width: "3rem",

                            "&[data-inactive]": {
                                cursor: "default",
                                visibility: "hidden",
                            },
                            // left button has reversed gradient
                            "&:first-of-type": {
                                background: theme.fn.linearGradient(
                                    90,
                                    "rgba(255, 255, 255, 1)",
                                    "rgba(255, 255, 255, 0)",
                                ),
                            },
                        },
                        controls: {
                            height: "100%",
                            top: 0,
                            padding: 0,
                        },
                    }}
                >
                    {searchOptions.map((item) => renderLinkItem(item))}
                </Carousel>
                <div className={classes.favoritesAndHistoryWrapper}>
                    <FavoriteAndRecentUserActionsViewer />
                </div>
            </Flex>
        </Flex>
    )
}
